import { apiClient } from "./apiClient";

export interface RefreshToken {
  id: number;
  device_name?: string | null;
  device_type?: string | null;
  created_at: string;
  last_online_at?: string | null;
  expire_data: string;
  is_active: boolean;
}

export const refreshTokensApi = {
  // Get all active refresh tokens
  getAll: async (): Promise<RefreshToken[]> => {
    const response = await apiClient.get<RefreshToken[]>("/v1/auth/get-refresh-tokens");
    return response.data;
  },

  // Delete specific refresh token (logout from specific device)
  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/v1/auth/session-logout/${id}`);
  },

  // Deactivate all refresh tokens
  deactivateAll: async (): Promise<void> => {
    await apiClient.post("/v1/auth/logout-all");
  },
};
